/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Picker_Dates_PlaceholderInputs */

const en_picker_dates_placeholder = /** @type {(inputs: Picker_Dates_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add dates`)
};

/**
* | output |
* | --- |
* | "Add dates" |
*
* @param {Picker_Dates_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const picker_dates_placeholder = /** @type {((inputs?: Picker_Dates_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Picker_Dates_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_picker_dates_placeholder(inputs)
});